import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const ReturnIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" width="24" height="24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillOpacity="0"
        d="M0 0H24V24H0z"
        transform="translate(-1132 -1765) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 78)"
      />
      <path
        fill="#666869"
        d="M15.189 3c4.843 0 8.77 3.926 8.77 8.77 0 4.842-3.927 8.768-8.77 8.768s-8.77-3.926-8.77-8.769S10.347 3 15.19 3zm0 1.846c-3.823 0-6.923 3.1-6.923 6.923 0 3.824 3.1 6.923 6.923 6.923 3.824 0 6.923-3.1 6.923-6.923s-3.1-6.923-6.923-6.923zM5.211 15.132c.51 0 .923.414.923.923 0 .474-.356.864-.815.917l-.108.006H2.352c-.51 0-.923-.413-.923-.923 0-.473.357-.863.816-.916l.107-.007h2.859zm8.996-7.581c.473 0 .863.356.916.815l.007.108-.001 3.812 2.176 1.152c.419.221.597.719.43 1.15l-.045.097c-.222.419-.719.597-1.15.43l-.098-.045-2.667-1.41c-.269-.143-.448-.407-.485-.704l-.006-.113v-4.37c0-.509.413-.922.923-.922zM.939 11.485l4.288.075c.51.008.916.429.907.938-.008.474-.371.858-.831.903l-.108.004-4.288-.074c-.51-.009-.916-.429-.907-.939.008-.473.371-.857.831-.902l.108-.005zm4.272-3.721c.51 0 .923.413.923.923 0 .473-.356.863-.815.917l-.108.006H2.352c-.51 0-.923-.413-.923-.923 0-.473.357-.864.816-.917l.107-.006h2.859z"
        transform="translate(-1132 -1765) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 78)"
      />
    </g>
  </IconWrapper>
);

export default memo(ReturnIcon);
